import PropTypes from "prop-types"
import React from "react"
import { Form } from "react-bootstrap"
import { CTDOMPurify } from "../../../data-utils/uiUtils.js"

function GameplayHelperModal({ title, subTitle, actionButtons, isFirstHelperModal }) {
  const [checked, setChecked] = React.useState(false)
  const handleChange = () => {
    setChecked(!checked)
  }

  return (
    <div className="gameplay-helper-modal-content">
      <h3 className="modal-title">{title}</h3>
      <div className="modal-subtitle" dangerouslySetInnerHTML={{ __html: CTDOMPurify.sanitize(subTitle) }}></div>

      {isFirstHelperModal && (
        <div className="checkbox-wrapper">
          <Form>
            <Form.Check type="checkbox" id={`gameplay-helper-skip-selection`}>
              <Form.Check.Input type="checkbox" checked={checked} onChange={handleChange} />
              <Form.Check.Label>{`Don't show me this again.`}</Form.Check.Label>
            </Form.Check>
          </Form>
        </div>
      )}

      <div className="modal-action-wrapper">
        {actionButtons.map((button, btnIndex) => (
          <button
            key={`gameplay-helper-btn-${btnIndex}`}
            className={`btn ${button.classNames.join(" ")}`}
            onClick={(e) => button.clickHandler(e, checked)}
          >
            {button.text}
          </button>
        ))}
      </div>
    </div>
  )
}

GameplayHelperModal.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  actionButtons: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      classNames: PropTypes.array,
      clickHandler: PropTypes.func,
    })
  ).isRequired,
  isFirstHelperModal: PropTypes.bool.isRequired,
}

export default GameplayHelperModal
